import { useEffect, useState } from "react";

function diff(target) {
  const now = new Date().getTime();
  const t = new Date(target).getTime();
  let d = Math.max(0, t - now);
  const days = Math.floor(d / 86400000); d -= days * 86400000;
  const hours = Math.floor(d / 3600000); d -= hours * 3600000;
  const minutes = Math.floor(d / 60000); d -= minutes * 60000;
  const seconds = Math.floor(d / 1000);
  return { days, hours, minutes, seconds };
}

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ date, light = false, compact = false, showSeconds = true }) {
  const [t, setT] = useState(() => diff(date));

  useEffect(() => {
    const id = setInterval(() => setT(diff(date)), 1000);
    return () => clearInterval(id);
  }, [date]);

  const items = [
    { v: t.days, l: "Días" },
    { v: pad(t.hours), l: "Horas" },
    { v: pad(t.minutes), l: "Min" },
    ...(showSeconds ? [{ v: pad(t.seconds), l: "Seg" }] : []),
  ];

  return (
    <div
      className={`flex items-start ${compact ? "gap-3 sm:gap-5" : "gap-6 sm:gap-10"}`}
      data-testid="countdown"
    >
      {items.map((it, i) => (
        <div key={it.l} className="flex items-start">
          <div className="text-center">
            <div className={`font-display leading-none tabular-nums ${compact ? "text-2xl sm:text-3xl" : "text-4xl sm:text-5xl"} ${light ? "text-white" : "text-ink"}`}>
              {it.v}
            </div>
            <div className={`overline mt-3 ${light ? "text-white/60" : "text-[color:var(--muted)]"}`}>
              {it.l}
            </div>
          </div>
          {i < items.length - 1 && (
            <span className={`font-display ${compact ? "text-lg sm:text-xl mx-1.5 sm:mx-2.5" : "text-3xl sm:text-4xl mx-3 sm:mx-5"} -mt-1 ${light ? "text-white/30" : "text-black/20"}`}>·</span>
          )}
        </div>
      ))}
    </div>
  );
}
